import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import YesNoField from './YesNoField';

const colSpan = { lg: 8, xs: 24 };

const LicenseAndFuelTax = ({ disabled = false }: { disabled?: boolean }) => {
    const { t } = useTranslation(['financeProductDetails']);

    return (
        <Row gutter={[16, 16]}>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.licenseAndFuelTaxViewable', {
                        returnObjects: true,
                    })}
                    disabled={disabled}
                    name="licenseAndFuelTax.isViewable"
                />
            </Col>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.licenseAndFuelTaxEditable', {
                        returnObjects: true,
                    })}
                    disabled={disabled}
                    name="licenseAndFuelTax.isEditable"
                />
            </Col>
        </Row>
    );
};

export default LicenseAndFuelTax;
